import { render, staticRenderFns } from "./AccountSettingSportM8Commission.vue?vue&type=template&id=3ac8b994&"
import script from "./AccountSettingSportM8Commission.vue?vue&type=script&lang=js&"
export * from "./AccountSettingSportM8Commission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports